import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {VisuallyHidden} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    GOOGLEPLACES_SUGGESTIONS_INSTRUCTIONS,
    GOOGLEPLACES_SUGGESTIONS_FOUND_RESULTS
} from '../../constants'

const GooglePlacesAccessibility = ({instructionsId, resultsCount = null}) => (
    <>
        <div id={instructionsId} style={{display: 'none'}}>
            <FormattedMessage {...GOOGLEPLACES_SUGGESTIONS_INSTRUCTIONS} />
        </div>
        <VisuallyHidden
            as="div"
            className="results-count"
            aria-live="assertive"
            aria-atomic="true"
        >
            {resultsCount !== null && (
                <FormattedMessage
                    {...GOOGLEPLACES_SUGGESTIONS_FOUND_RESULTS}
                    values={{num: resultsCount}}
                />
            )}
        </VisuallyHidden>
    </>
)

GooglePlacesAccessibility.propTypes = {
    instructionsId: PropTypes.string.isRequired,
    resultsCount: PropTypes.number
}

export default GooglePlacesAccessibility